<div class="up-arrow" [class.disabled]="disabled" *ngIf="value > 0"></div>
<div class="down-arrow" [class.disabled]="disabled" *ngIf="value < 0"></div>
{{ value > 0 ? '+' : '' }}{{ value | formatNumber }}%
